var exports = {
  "vK": "AnalyticsConsentBanner.module__banner___dTJRVl",
  "Qq": "AnalyticsConsentBanner.module__text___dTJRVl",
  "Rf": "AnalyticsConsentBanner.module__policyLink___dTJRVl",
  "o1": "AnalyticsConsentBanner.module__actions___dTJRVl",
};

module.exports = exports;
